const price = `
    price_range {
        minimum_price {
            regular_price {
                value
                currency
            }
            final_price {
                value
                currency
            }
            discount {
                percent_off
                amount_off
            }
        }
        promotion_price {
            discount {
                percent_off
            }
        }
    }
`;

const items = `{
    sku
    type_id
    name
    url_key
    stock_status
    image {
        url
        label
    }
    ${price}
}`;

const getCategoryProducts = `
    query Products($search: String, $filter: ProductAttributeFilterInput, $sort: ProductAttributeSortInput, $currentPage: Int, $pageSize: Int) {
        products(search: $search, filter: $filter, sort: $sort, currentPage: $currentPage, pageSize: $pageSize) {
            items ${items}
            sort_fields {
                options {
                    value
                    label
                    order
                }
            }
            total_count
            page_info {
                current_page
            }
        }
    }
`;

const getProductsOfTheWeek = input =>`{
    getProductsOfTheWeek(input: ${input}) {
        items ${items}
        total_pages
    }
}`;

const getRecommendedProducts = input => `{
    getRecommendedProducts(input: ${input}) {
        items ${items}
        total_pages
    }
}`;

const getProductsOnSale = input => `{
    getProductsOnSale(input: ${input}) {
        items ${items}
        total_pages
    }
}`;

const getProducts = ({ pageSize, currentPage }) => `
    query Search($query: String) {
        search(query: $query) {
            query
            magento_catalog_product(pageSize: ${pageSize}, currentPage: ${currentPage}) {
                items ${items}
                total_count
                page_info {
                    current_page
                }
            }
        }
    }
`;

export default {
    getProducts,
    getCategoryProducts,
    getProductsOfTheWeek,
    getRecommendedProducts,
    getProductsOnSale,
};
